import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tarneaeg pakiautomaati tellides

  <span style="color:#85c1dc;">**FI:**</span>
  Toimitusaika pakettiautomaattiin tilattaessa

  <span style="color:#85c1dc;">**RU:**</span>
  Срок доставки при заказе в посылочный терминал
*/
/* @__NO_SIDE_EFFECTS__ */
const m1291 = msg(
  mf`Tarneaeg pakiautomaati tellides`,
  mf`Toimitusaika pakettiautomaattiin tilattaessa`,
  mf`Срок доставки при заказе в посылочный терминал`,
)

export { m1291 as 'w.module.delivery_section.delivery_time.parcel_machine' }